import { PositionConfigSnapshot } from '../../../types/Ad.api.type';

interface Props {
  positions: PositionConfigSnapshot[];
  todayLimitReached: Record<string, number>;
}

const POSITION_LABELS: Record<string, string> = {
  HOME_TOP: '홈 상단',
  HOME_MIDDLE: '홈 중단',
  MAIN_FEED_TOP: '메인 상단',
  MAIN_FEED: '메인 피드',
  MAIN_FEED_IMAGE: '메인 피드 이미지',
  POPULAR_FEED_TOP: '인기설문 상단',
  POPULAR_FEED: '인기설문',
  MY_FEED_TOP: '내설문 상단',
  MY_FEED: '내설문',
  DETAIL_COMMENT: '상세 댓글',
  ATTENDANCE: '출석 달력 하단',
  BENEFIT: '혜택 페이지',
  ATTENDANCE_RESULT: '출석 완료',
  EXCHANGE_RESULT: '환전 완료',
  WEEKLY_MISSION_RESULT: '미션 완료',
};

function formatDate(iso: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${d.getMonth() + 1}/${d.getDate()}`;
}

function truncate(id: string | null, len = 20): string {
  if (!id) return '—';
  return id.length > len ? id.slice(0, len) + '…' : id;
}

/** G1-2 섹션 2: 배너 위치별 광고ID + S11-6 빈도 제한 상태 */
const AdPositionSnapshot = ({ positions, todayLimitReached }: Props) => {
  return (
    <div>
      <h4 className="text-sm font-semibold mb-2 text-gray-700">
        2. 배너 위치별 광고ID + 빈도 제한 ({positions.length}개)
      </h4>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs border-collapse">
          <thead className="bg-gray-50">
            <tr>
              <th className="border px-2 py-1 text-left">위치</th>
              <th className="border px-2 py-1 text-left">광고ID</th>
              <th className="border px-2 py-1 text-center">토스%</th>
              <th className="border px-2 py-1 text-center">토스 활성</th>
              <th className="border px-2 py-1 text-center">관측</th>
              <th className="border px-2 py-1 text-center">상한</th>
              <th className="border px-2 py-1 text-center">상한값</th>
              <th className="border px-2 py-1 text-center">오늘 도달</th>
              <th className="border px-2 py-1 text-center">최근변경</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((p) => (
              <tr key={p.position} className="hover:bg-gray-50">
                <td className="border px-2 py-1 font-medium">{POSITION_LABELS[p.position] ?? p.position}</td>
                <td className="border px-2 py-1 font-mono text-[10px] text-gray-600">{truncate(p.tossAdGroupId)}</td>
                <td className="border px-2 py-1 text-center">{p.tossAdRatio}%</td>
                <td className="border px-2 py-1 text-center">{p.isTossAdEnabled ? '✅' : '—'}</td>
                <td className="border px-2 py-1 text-center">{p.observationEnabled ? '🟢' : '—'}</td>
                <td className="border px-2 py-1 text-center">{p.frequencyLimitEnabled ? '🟢 ON' : '—'}</td>
                <td className="border px-2 py-1 text-center">{p.dailyImpressionLimit ?? '—'}</td>
                <td className="border px-2 py-1 text-center font-semibold">{todayLimitReached[p.position] ?? 0}명</td>
                <td className="border px-2 py-1 text-center text-gray-500">{formatDate(p.modDateTime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdPositionSnapshot;
